import { Outlet, ScrollRestoration } from 'react-router-dom';
import { AmaruWordmark } from './amaru-wordmark';
import styles from './app-layout.module.css';

// `au-scope` y el rol `body` se declaran una vez acá, para todas las rutas de src/fsd/.
// `ScrollRestoration`: una navegación nueva arranca arriba y el botón atrás recupera el scroll.
// Barras provisorias, como `<div>`: ver frontend-fsd.md § Marco provisorio.
export function AppLayout() {
  return (
    <div className={`au-scope ${styles.appLayout}`}>
      <div className={styles.topBar}>
        <AmaruWordmark height={18} />
      </div>
      <div className={styles.body}>
        <div className={styles.sideBar} />
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
      <ScrollRestoration />
    </div>
  );
}
